<template>
  <div class="content">

    <el-row class="bgW">
      <el-col :span="22">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <!-- <el-form-item label="创建时间">
            <el-date-picker v-model="search.date" type="daterange" class="w220" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" />
          </el-form-item> -->
          <el-form-item label="类型">
            <el-select v-model="search.type" clearable placeholder="请选择类型" class="w120" @change="onTypeChange">
              <el-option v-for="i in options.typeList" :key="i.value" :label="i.label" :value="i.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="模板内容">
            <el-input v-model="search.content" class="w200" clearable placeholder="请输入模板内容" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态" class="w120">
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="2" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="商品名称" v-if="search.type !== 2">
            <el-input v-model="search.goods_name" class="w200" clearable placeholder="请输入商品名称" />
          </el-form-item>
          <el-form-item label="品项名称" v-if="search.type !== 1">
            <el-input v-model="search.item_name" class="w200" clearable placeholder="请输入品项名称" />
          </el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>

    <div class="accountCon">
      <div style="padding:0 10px 10px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('add')">新增模板</el-button>
      </div>

      <el-table
        :data="list"
        size="small"
        border
        :cell-style="$style.cellStyle"
        :header-cell-style="$style.rowClass"
      >
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="类型" prop="type" width="80" align="center">
          <template slot-scope="{ row }">
            {{ row.type === 1 ? '商品' : '品项' }}
          </template>
        </el-table-column>
        <el-table-column label="关联商品/品项名称" prop="item_goods_name" min-width="160">
          <template slot-scope="{ row }">
            <div
              :ref="'cell_item_goods_name_' + row.id"
              class="multi-line"
              :class="{ expanded: expandedRows[row.id] }"
            >{{ row.item_goods_name }}</div>
            <span
              v-if="needExpand(row, 'item_goods_name')"
              class="theme cp"
              @click="toggleExpand(row)"
            >{{ expandedRows[row.id] ? '收起' : '展开' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="治疗记录或方案" prop="content" min-width="200">
          <template slot-scope="{ row }">
            <div
              :ref="'cell_content_' + row.id"
              class="multi-line"
              :class="{ expanded: expandedRows[row.id] }"
            >{{ row.content }}</div>
            <span
              v-if="needExpand(row, 'content')"
              class="theme cp"
              @click="toggleExpand(row)"
            >{{ expandedRows[row.id] ? '收起' : '展开' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" width="160" />
        <el-table-column label="状态" prop="status" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.status"
              :active-value="1"
              :inactive-value="2"
              active-color="#33BEA7"
              inactive-color="#dcdfe6"
              @change="toggleStatus(row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="{ row }">
            <span class="theme mr10" @click="openDialog('edit', row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        class="page tc mt10"
        :total="page.total"
        :page.sync="page.page"
        :limit.sync="page.limit"
        @pagination="getList"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form
        ref="formRef"
        :model="form"
        label-width="150px"
        label-suffix="："
        size="mini"
        :rules="rules"
      >
        <el-form-item label="模板类型" prop="type">
          <el-radio-group v-model="form.type" :disabled="dialogType === 'detail'" @change="onFormTypeChange">
            <el-radio v-for="i in options.typeList" :key="i.value" :label="i.value">{{ i.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联商品" prop="item_goods_id" v-if="form.type === 1">
          <el-select
            v-model="form.item_goods_id"
            filterable remote clearable reserve-keyword class="w400"
            :disabled="dialogType === 'detail'"
            :loading="options.goodsLoading"
            :remote-method="remoteMethodGoods"
            placeholder="请输入商品名称搜索"
            @change="onSelectGoods"
          >
            <el-option v-for="i in options.goodsList" :key="i.id" :label="i.name" :value="i.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="关联品项" prop="item_goods_id" v-if="form.type === 2">
          <el-select
            v-model="form.item_goods_id"
            filterable remote clearable reserve-keyword class="w400"
            :disabled="dialogType === 'detail'"
            :loading="options.itemLoading"
            :remote-method="remoteMethodItems"
            placeholder="请输入品项名称搜索"
            @change="onSelectItem"
          >
            <el-option v-for="i in options.itemsList" :key="i.id" :label="i.name" :value="i.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="治疗记录或方案" prop="content">
          <el-input type="textarea" v-model="form.content" :autosize="{ minRows: 4 }" class="w400" maxlength="1000" show-word-limit :readonly="dialogType === 'detail'" placeholder="请输入治疗记录或方案" />
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="form.status" :disabled="dialogType === 'detail'" :inactive-value="2" :active-value="1" active-color="#33BEA7" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="dialogType !== 'detail'"
          @click="submitForm"
        >
          确认保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination'
import { getTemplateList, addTemplate, editTemplate } from '@/api/goods'
import { getGoodList} from '@/api/goods'

class Page {
  total = 0
  page = 1
  limit = 10
}

class Search {
  type = ''
  goods_name = ''
  item_name = ''
  date = []
  status = ''
}
class Options {
  typeList = [
    { label: '商品', value: 1 },
    { label: '品项', value: 2 }
  ]
  goodsList = []
  itemsList = []
  goodsLoading = false
  itemLoading = false
}

class Form {
  id = ''
  type = 1
  item_goods_id = ''
  content = ''
  status = 1
}

export default {
  name: 'TemplateList',
      components: { pagination },
      data() {
        return {
          search: new Search(),
          page: new Page(),
          options: new Options(),
          list: [],
          dialogVisible: false,
          dialogType: 'add',
          dialogTitle: '新增模板',
          form: new Form(),
          formRef: 'formRef',
          expandedRows: {},
          overflowMap: {},
          rules: {
            type: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
            item_goods_id: [{ required: true, message: '请选择关联商品/品项', trigger: 'change' }],
            content: [{ required: true, message: '请输入治疗记录或方案', trigger: 'blur' }]
          }
        }
      },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.getList();
  },
  methods: {
    toggleExpand(row) {
      this.$set(this.expandedRows, row.id, !this.expandedRows[row.id])
    },
    needExpand(row, prop) {
      return this.overflowMap[row.id + '_' + prop] === true
    },
    checkOverflow() {
      const map = {}
      const fields = ['item_goods_name', 'content']
      this.list.forEach(row => {
        fields.forEach(f => {
          const refKey = 'cell_' + f + '_' + row.id
          const el = this.$refs[refKey]
          const dom = Array.isArray(el) ? el[0] : el
          if (dom) {
            // 临时移除 expanded 以测真实高度
            const wasExpanded = this.expandedRows[row.id]
            if (wasExpanded) dom.classList.remove('expanded')
            const overflow = dom.scrollHeight > dom.clientHeight + 1
            map[row.id + '_' + f] = overflow
            if (wasExpanded) dom.classList.add('expanded')
          }
        })
      })
      this.overflowMap = map
    },
    onTypeChange() {
      this.search.goods_name = ''
      this.search.item_name = ''
    },
    onFormTypeChange() {
      this.form.item_goods_id = ''
    },
    fillRelationOptions(row) {
      if (!row || !row.item_goods_id) return
      const opt = { id: row.item_goods_id, name: row.item_goods_name }
      if (row.type === 1) this.options.goodsList = [opt]
      else if (row.type === 2) this.options.itemsList = [opt]
    },
    remoteMethodGoods(query) {
      this.options.goodsLoading = true
      getGoodList({ name: query, type: 2, action: 'search' }).then(res => {
        this.options.goodsList = res || []
      }).finally(() => {
        this.options.goodsLoading = false
      })
    },
    remoteMethodItems(query) {
      this.options.itemLoading = true
      getGoodList({ name: query, type: 1, action: 'search' }).then(res => {
        this.options.itemsList = res || []
      }).finally(() => {
        this.options.itemLoading = false
      })
    },
    onSelectGoods(val) {
      const goods = this.options.goodsList.find(i => i.id === val)
      if (goods) {
        this.form.item_goods_name = goods.name
      }
    },
    onSelectItem(val) {
      const item = this.options.itemsList.find(i => i.id === val)
      if (item) {
        this.form.item_goods_name = item.name
      }
    },
    async getList(option) {
      if (option === 'search') this.page = new Page()
      getTemplateList({
        type: this.search.type,
        status: this.search.status,
        content: this.search.content,
        time_start: this.search.date && this.search.date[0],
        time_end: this.search.date && this.search.date[1],
        ...this.page
      }).then(res=>{
        this.list = res.list || [];
        this.page.total = res.count;
        this.expandedRows = {}
        this.$nextTick(this.checkOverflow)
      })
    },

    async openDialog(type, row = {}) {
      this.dialogType = type
      this.dialogVisible = true
      this.remoteMethodGoods('');
      this.remoteMethodItems('');
      if (type === 'add') {
        this.dialogTitle = '新增模板'
        this.form = new Form()
      } else if (type === 'edit') {
        this.dialogTitle = '编辑模板'
        this.form = { id: row.id, content: row.content, type: row.type, item_goods_id: row.item_goods_id, status: row.status, }
        this.fillRelationOptions(row)
      }
    },
    async toggleStatus(row) {
      try {
        await editTemplate({ id: row.id, status: row.status })
        this.$message.success(row.status === 1 ? '已启用' : '已禁用')
      } catch (err) {
        // 失败回滚
        row.status = row.status === 1 ? 2 : 1
        this.$message.error(err)
      }
    },
    async submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          if (this.dialogType === 'add') {
            await addTemplate(this.form)
          } else if (this.dialogType === 'edit') {
            await editTemplate(this.form)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.getList()
        } catch (err) {
          // this.$message.error(err)
        }
      })
    },

    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.multi-line {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  line-height: 18px;
  &.expanded {
    -webkit-line-clamp: unset;
    overflow: visible;
  }
}
.cp { cursor: pointer; }
</style>